/** Client mirror of key CasaMapa Vendor Directory permission codes. */

export const VENDOR_DIRECTORY_PERMISSIONS = {
  VENDORS_VIEW: "casamapa.vendor_directory.vendors.view",
  VENDORS_CREATE: "casamapa.vendor_directory.vendors.create",
  VENDORS_UPDATE: "casamapa.vendor_directory.vendors.update",
  VENDORS_ARCHIVE: "casamapa.vendor_directory.vendors.archive",
  VENDORS_RESTORE: "casamapa.vendor_directory.vendors.restore",
  VENDORS_UNPUBLISH: "casamapa.vendor_directory.vendors.unpublish",
  VENDORS_REACTIVATE: "casamapa.vendor_directory.vendors.reactivate",
  VENDORS_ASSIGN: "casamapa.vendor_directory.vendors.assign",
  VENDORS_PUBLISH: "casamapa.vendor_directory.vendors.publish",
  VENDORS_SUSPEND: "casamapa.vendor_directory.vendors.suspend",
  VENDORS_VIEW_PRIVATE: "casamapa.vendor_directory.vendors.view_private",
  VENDORS_VIEW_SENSITIVE_EVIDENCE: "casamapa.vendor_directory.vendors.view_sensitive_evidence",
  CANDIDATES_VIEW: "casamapa.vendor_directory.candidates.view",
  CANDIDATES_UPDATE: "casamapa.vendor_directory.candidates.update",
  CANDIDATES_ACCEPT: "casamapa.vendor_directory.candidates.accept",
  CANDIDATES_REJECT: "casamapa.vendor_directory.candidates.reject",
  CANDIDATES_DEFER: "casamapa.vendor_directory.candidates.defer",
  CANDIDATES_ASSIGN: "casamapa.vendor_directory.candidates.assign",
  IMPORTS_VIEW: "casamapa.vendor_directory.imports.view",
  IMPORTS_CREATE: "casamapa.vendor_directory.imports.create",
  IMPORTS_CONFIGURE: "casamapa.vendor_directory.imports.configure",
  IMPORTS_EXECUTE: "casamapa.vendor_directory.imports.execute",
  IMPORTS_RETRY: "casamapa.vendor_directory.imports.retry",
  IMPORTS_CANCEL: "casamapa.vendor_directory.imports.cancel",
  IMPORTS_ROLLBACK: "casamapa.vendor_directory.imports.rollback",
  IMPORTS_EXPORT_ERRORS: "casamapa.vendor_directory.imports.export_errors",
  SOURCES_VIEW: "casamapa.vendor_directory.sources.view",
  SOURCES_CREATE: "casamapa.vendor_directory.sources.create",
  SOURCES_UPDATE: "casamapa.vendor_directory.sources.update",
  SOURCES_ACTIVATE: "casamapa.vendor_directory.sources.activate",
  SOURCES_DEACTIVATE: "casamapa.vendor_directory.sources.deactivate",
  COLLECTIONS_VIEW: "casamapa.vendor_directory.collections.view",
  COLLECTIONS_CONFIGURE: "casamapa.vendor_directory.collections.configure",
  COLLECTIONS_EXECUTE: "casamapa.vendor_directory.collections.execute",
  COLLECTIONS_CANCEL: "casamapa.vendor_directory.collections.cancel",
  COLLECTIONS_RETRY: "casamapa.vendor_directory.collections.retry",
  COLLECTIONS_VIEW_RAW: "casamapa.vendor_directory.collections.view_raw",
  DUPLICATES_VIEW: "casamapa.vendor_directory.duplicates.view",
  DUPLICATES_RESOLVE: "casamapa.vendor_directory.duplicates.resolve",
  DUPLICATES_MERGE: "casamapa.vendor_directory.duplicates.merge",
  DUPLICATES_KEEP_SEPARATE: "casamapa.vendor_directory.duplicates.keep_separate",
  DUPLICATES_LINK_BRANCH: "casamapa.vendor_directory.duplicates.link_branch",
  DUPLICATES_REVERSE_MERGE: "casamapa.vendor_directory.duplicates.reverse_merge",
  RESOLUTION_VIEW: "casamapa.vendor_directory.resolution.view",
  RESOLUTION_ASSIGN: "casamapa.vendor_directory.resolution.assign",
  RESOLUTION_DECIDE: "casamapa.vendor_directory.resolution.decide",
  RESOLUTION_APPLY: "casamapa.vendor_directory.resolution.apply",
  RESOLUTION_GENERATE: "casamapa.vendor_directory.resolution.generate",
  RESOLUTION_RECOMPUTE: "casamapa.vendor_directory.resolution.recompute",
  VERIFICATION_VIEW: "casamapa.vendor_directory.verification.view",
  VERIFICATION_ASSIGN: "casamapa.vendor_directory.verification.assign",
  VERIFICATION_PERFORM: "casamapa.vendor_directory.verification.perform",
  VERIFICATION_APPROVE: "casamapa.vendor_directory.verification.approve",
  VERIFICATION_VIEW_EVIDENCE: "casamapa.vendor_directory.verification.view_evidence",
  CREDENTIALS_VIEW: "casamapa.vendor_directory.credentials.view",
  CREDENTIALS_CREATE: "casamapa.vendor_directory.credentials.create",
  CREDENTIALS_UPDATE: "casamapa.vendor_directory.credentials.update",
  CREDENTIALS_VERIFY: "casamapa.vendor_directory.credentials.verify",
  CREDENTIALS_REJECT: "casamapa.vendor_directory.credentials.reject",
  CREDENTIALS_REVOKE: "casamapa.vendor_directory.credentials.revoke",
  CLAIMS_VIEW: "casamapa.vendor_directory.claims.view",
  CLAIMS_ASSIGN: "casamapa.vendor_directory.claims.assign",
  CLAIMS_REQUEST_INFORMATION: "casamapa.vendor_directory.claims.request_information",
  CLAIMS_APPROVE: "casamapa.vendor_directory.claims.approve",
  CLAIMS_REJECT: "casamapa.vendor_directory.claims.reject",
  CLAIMS_REVOKE: "casamapa.vendor_directory.claims.revoke",
  CLAIMS_VIEW_EVIDENCE: "casamapa.vendor_directory.claims.view_evidence",
  RANKING_VIEW: "casamapa.vendor_directory.ranking.view",
  RANKING_PREVIEW: "casamapa.vendor_directory.ranking.preview",
  RANKING_CONFIGURE: "casamapa.vendor_directory.ranking.configure",
  RANKING_OVERRIDE: "casamapa.vendor_directory.ranking.override",
  RANKING_REMOVE_OVERRIDE: "casamapa.vendor_directory.ranking.remove_override",
  RANKING_VIEW_HISTORY: "casamapa.vendor_directory.ranking.view_history",
  RANKING_MANAGE_FEATURED: "casamapa.vendor_directory.ranking.manage_featured",
  RANKING_MANAGE_SPONSORED: "casamapa.vendor_directory.ranking.manage_sponsored",
  REVIEWS_MODERATE: "casamapa.vendor_directory.reviews.moderate",
  COMPLAINTS_RESOLVE: "casamapa.vendor_directory.complaints.resolve",
  LEADS_VIEW: "casamapa.vendor_directory.leads.view",
  LEADS_VIEW_PRIVATE: "casamapa.vendor_directory.leads.view_private",
  PRIVACY_REQUESTS_VIEW: "casamapa.vendor_directory.privacy_requests.view",
  PRIVACY_REQUESTS_ASSIGN: "casamapa.vendor_directory.privacy_requests.assign",
  PRIVACY_REQUESTS_RESOLVE: "casamapa.vendor_directory.privacy_requests.resolve",
  PRIVACY_REQUESTS_SUPPRESS: "casamapa.vendor_directory.privacy_requests.suppress_profile",
  PRIVACY_REQUESTS_ANONYMIZE: "casamapa.vendor_directory.privacy_requests.anonymize",
  PRIVACY_REQUESTS_VIEW_SENSITIVE: "casamapa.vendor_directory.privacy_requests.view_sensitive",
  AUDIT_VIEW: "casamapa.vendor_directory.audit.view",
  SETTINGS_VIEW: "casamapa.vendor_directory.settings.view",
  SETTINGS_UPDATE: "casamapa.vendor_directory.settings.update",
  ANALYTICS_VIEW: "casamapa.vendor_directory.analytics.view",
  ANALYTICS_VIEW_EXECUTIVE: "casamapa.vendor_directory.analytics.view_executive",
  ANALYTICS_VIEW_OPERATIONS: "casamapa.vendor_directory.analytics.view_operations",
  ANALYTICS_VIEW_QUALITY: "casamapa.vendor_directory.analytics.view_quality",
  ANALYTICS_VIEW_RANKING: "casamapa.vendor_directory.analytics.view_ranking",
  ANALYTICS_VIEW_PRIVACY: "casamapa.vendor_directory.analytics.view_privacy",
  ANALYTICS_VIEW_SENSITIVE_AGGREGATES: "casamapa.vendor_directory.analytics.view_sensitive_aggregates",
  ANALYTICS_EXPORT: "casamapa.vendor_directory.analytics.export",
  ANALYTICS_CONFIGURE_ALERTS: "casamapa.vendor_directory.analytics.configure_alerts",
  ANALYTICS_RUN_BACKFILL: "casamapa.vendor_directory.analytics.run_backfill",
  MAINTENANCE_VIEW: "casamapa.vendor_directory.maintenance.view",
  MAINTENANCE_ASSIGN: "casamapa.vendor_directory.maintenance.assign",
  MAINTENANCE_EXECUTE: "casamapa.vendor_directory.maintenance.execute",
  MAINTENANCE_APPROVE: "casamapa.vendor_directory.maintenance.approve",
  MAINTENANCE_CANCEL: "casamapa.vendor_directory.maintenance.cancel",
  MAINTENANCE_CONFIGURE: "casamapa.vendor_directory.maintenance.configure",
  MAINTENANCE_ACTIVATE_POLICY: "casamapa.vendor_directory.maintenance.activate_policy",
  MAINTENANCE_MANAGE_REVERIFICATION: "casamapa.vendor_directory.maintenance.manage_reverification",
  MAINTENANCE_EXECUTE_RETENTION: "casamapa.vendor_directory.maintenance.execute_retention",
  MAINTENANCE_VIEW_FAILURES: "casamapa.vendor_directory.maintenance.view_failures",
  PILOT_VIEW: "casamapa.vendor_directory.pilot.view",
  PILOT_CONFIGURE: "casamapa.vendor_directory.pilot.configure",
  PILOT_MANAGE_SEED_BATCHES: "casamapa.vendor_directory.pilot.manage_seed_batches",
  PILOT_APPROVE_PUBLICATION: "casamapa.vendor_directory.pilot.approve_publication",
  PILOT_ACTIVATE: "casamapa.vendor_directory.pilot.activate",
  PILOT_PAUSE: "casamapa.vendor_directory.pilot.pause",
  PILOT_ROLLBACK: "casamapa.vendor_directory.pilot.rollback",
  PILOT_VIEW_SENSITIVE_METRICS: "casamapa.vendor_directory.pilot.view_sensitive_metrics",
  PILOT_EXPORT: "casamapa.vendor_directory.pilot.export",
  EXPANSION_VIEW: "casamapa.vendor_directory.expansion.view",
  EXPANSION_CONFIGURE: "casamapa.vendor_directory.expansion.configure",
  EXPANSION_MANAGE_SEED_BATCHES: "casamapa.vendor_directory.expansion.manage_seed_batches",
  EXPANSION_ACTIVATE: "casamapa.vendor_directory.expansion.activate",
  EXPANSION_PAUSE: "casamapa.vendor_directory.expansion.pause",
  EXPANSION_ROLLBACK: "casamapa.vendor_directory.expansion.rollback",
  EXPANSION_VIEW_SENSITIVE_METRICS: "casamapa.vendor_directory.expansion.view_sensitive_metrics",
  MARKETPLACE_VIEW: "casamapa.vendor_directory.marketplace.view",
  MARKETPLACE_CONFIGURE: "casamapa.vendor_directory.marketplace.configure",
  MARKETPLACE_BILLING: "casamapa.vendor_directory.marketplace.billing",
  MARKETPLACE_SUBSCRIPTIONS: "casamapa.vendor_directory.marketplace.subscriptions",
  MARKETPLACE_CREDITS: "casamapa.vendor_directory.marketplace.credits",
  MARKETPLACE_CAMPAIGNS: "casamapa.vendor_directory.marketplace.campaigns",
  MARKETPLACE_ORDERS: "casamapa.vendor_directory.marketplace.orders",
  MARKETPLACE_PAYOUTS: "casamapa.vendor_directory.marketplace.payouts",
  MARKETPLACE_PARTNERS: "casamapa.vendor_directory.marketplace.partners",
  MARKETPLACE_RECONCILE: "casamapa.vendor_directory.marketplace.reconcile",
  MARKETPLACE_REFUNDS: "casamapa.vendor_directory.marketplace.refunds",
  SECURITY_VIEW_FINDINGS: "casamapa.vendor_directory.security.view_findings",
  SECURITY_MANAGE_FINDINGS: "casamapa.vendor_directory.security.manage_findings",
  SECURITY_ACCEPT_RISK: "casamapa.vendor_directory.security.accept_risk",
  PERFORMANCE_VIEW: "casamapa.vendor_directory.performance.view",
};

export function hasVendorDirectoryPermission(permissions = [], code) {
  return (permissions || []).includes(code);
}

export function hasAnyVendorDirectoryPermission(permissions = [], codes = []) {
  return codes.some((code) => hasVendorDirectoryPermission(permissions, code));
}
